import { TABS } from '@/pages/cars/list/config'
import { useQueryStringify } from '@/utils/useAutoQuery'

export default function () {
  // 跳转
  function goUrl(key, row) {
    const path = '/vehicle/vehicleManage/list'
    const query = {
      b: key,
      f: {
        brandSeriesModel: {
          brandId: row.brandId ? Number(row.brandId) : '', // 品牌
          seriesId: row.seriesId ? Number(row.seriesId) : '', // 车系
          modelId: row.carModelId ? Number(row.carModelId) : '', // 车型
        },
      },
    }
    this.$router.push(
      `${path}?${useQueryStringify(query)}`,
    )
  }
  // 全部、待入库、待处理、待租、已租、退出运营
  const columns = [
    {
      name: 'deptName',
      columnProps: {
        label: '部门',
        prop: 'deptName',
      },
    }, {
      name: 'brandName',
      columnProps: {
        label: '品牌',
        prop: 'brandName',
        width: 100,
      },
    }, {
      name: 'seriesName',
      columnProps: {
        label: '车系',
        prop: 'seriesName',
        width: 100,
      },
    }, {
      name: 'carModelName',
      columnProps: {
        label: '车型',
        prop: 'carModelName',
        width: 160,
      },
    },
    {
      name: 'allCarNum',
      columnProps: {
        label: '全部',
        prop: 'allCarNum',
      },
      render: ({ row }) => {
        const configObj = {
          label: 'span',
          value: row.allCarNum || 0,
          className: 'item-active',
          fn: () => goUrl.call(this, TABS.All, row),
        }
        return this.renderContent(configObj)
      },
    },
    {
      name: 'toDealNum',
      columnProps: {
        label: '待处理',
        prop: 'toDealNum',
      },
      render: ({ row }) => {
        const configObj = {
          label: 'span',
          value: row.toDealNum || 0,
          className: 'item-active',
          fn: () => goUrl.call(this, TABS.WaitForHandle, row),
        }
        return this.renderContent(configObj)
      },
    },
    {
      name: 'toLeaseNum',
      columnProps: {
        label: '待租',
        prop: 'toLeaseNum',
      },
      render: ({ row }) => {
        const configObj = {
          label: 'span',
          value: row.toLeaseNum || 0,
          className: 'item-active',
          fn: () => goUrl.call(this, TABS.WaitForRent, row),
        }
        return this.renderContent(configObj)
      },
    },
    {
      name: 'leasedNum',
      columnProps: {
        label: '已租',
        prop: 'leasedNum',
      },
      render: ({ row }) => {
        const configObj = {
          label: 'span',
          value: row.leasedNum || 0,
          className: 'item-active',
          fn: () => goUrl.call(this, TABS.AfterRent, row),
        }
        return this.renderContent(configObj)
      },
    },
    {
      name: 'exitOperationCarNum',
      columnProps: {
        label: '退出运营',
        prop: 'exitOperationCarNum',
      },
      render: ({ row }) => {
        const configObj = {
          label: 'span',
          value: row.exitOperationCarNum || 0,
          className: 'item-active',
          fn: () => goUrl.call(this, TABS.OutCar, row),
        }
        return this.renderContent(configObj)
      },
    },
  ]
  return {
    columns,
  }
}
